import ProfPlan from "./ic-professional.svg"
import PlanChat from "./ic-chat.svg"
import PlanChart from "./ic-chart.svg"
import PlanSave from "./ic-save.svg"
import PlanSearch from "./ic-doc-search.svg"

function ComponentPro() {
    return (
        <div className='w-80 flex-shrink-0 flex flex-col space-y-3 justify-center items-center lg:w-96'>
            <img className="h-10" src={ProfPlan} alt="Professional Plan" />
            <h5 className="text-xl font-medium text-center">The ultimate ClassQ.</h5>
            {/* <h5 className="text-xl font-medium text-center">32000DA</h5> */}
            <div className='w-full h-px rounded-full bg-secondary bg-opacity-30'></div>
            <div className="flex flex-col space-y-3" dir="rtl">
                <p className="text-lg text-center" dir="ltr">Plus و Basic ميزات باقة</p>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanChat} alt="chat" />
                    </div>
                    <p className="text-lg content-center">الاتصال بأي شخص عبر البريد الإلكتروني أو المكالمات.</p>
                </div>
                <div className="flex flex-row space-x-3  items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanChart} alt="graph" />
                    </div>
                    <p className="text-lg content-center">إحصائيات ورسوم بيانية تفصيلية احترافية.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanSave} alt="save" />
                    </div>
                    <p className="text-lg content-center">النسخ الاحتياطي واستعادة البيانات بشكل آمن.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanSearch} alt="doc search" />
                    </div>
                    <p className="text-lg content-center">البحث المباشر عن الأفواج أو التلاميذ.</p>
                </div>
            </div>
        </div>);
}

export default ComponentPro;